/**
 * Contact us script
 * 
 * @author HammersportMarketing
 */
import "../../sass/contact.scss";
import intlTelInput from 'intl-tel-input';
import "../components/contact-form";

// intl tel input inits
const contactFormTel = document.querySelector("#contact-form-tel");
export let contactFormPhone = intlTelInput(contactFormTel, {
    utilsScript: process.env.THEME_URL + "assets/build/js/utilsScript.bundle.js",
});